"use client";

import { Navbar } from "@/components/Navbar";
import BookingSearch from "@/components/BookingSearch";
import { Footer } from "@/components/Footer";
import { siteConfig } from "@/config/siteConfig";

export default function OnlineBooking() {
  return (
    <div className="min-h-screen bg-background overflow-x-hidden">
      <Navbar />
      <main>
        {/* Hero Header */}
        <section className="relative py-20 bg-gradient-to-b from-primary/10 to-background">
          <div className="container mx-auto px-4">
            <h1 className="font-display text-4xl md:text-5xl font-bold mb-4">
              Book Your <span className="text-gradient">Journey</span>
            </h1>
            <p className="text-xl text-muted-foreground max-w-2xl">
              Search available buses and book your ticket in minutes. Same easy booking experience you know and love.
            </p>
          </div>
        </section>

        {/* Booking Form - Same as home screen */}
        <section className="section-padding">
          <div className="container mx-auto px-4">
            <div className="max-w-6xl mx-auto">
              <BookingSearch />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
}
